export default __webpack_public_path__ + "static/media/kids.27f92282.svg";